import React from 'react';
import { Button, Modal } from '../../../../Components/uielements';
import {
  TwoColumns,
  ModalButtonWrapper,
  ModalWrapper,
} from '../../../../services/settings/appStyle/global.style';
import { ModalLabel } from '../../UserV2/user.style';
import { IntlMessages } from '../../../../helper/langHelper';

const ViewGeofenceDetailsModal = ({ onClose, data }) => {
  return (
    <>
      <Modal
        isOpen={true}
        onClose={onClose}
        title={<IntlMessages id="modal.title.geofence.details" />}
      >
        <ModalWrapper>
          <>
            <TwoColumns>
              <ModalLabel>
                <IntlMessages id="table.col.account.owner" /> :
              </ModalLabel>
              <ModalLabel isCapitalize={true}>{data?.companyId?.name}</ModalLabel>
            </TwoColumns>
            <TwoColumns>
              <ModalLabel>
                <IntlMessages id="table.col.premise.name" /> :
              </ModalLabel>
              <ModalLabel>{data?.premiseId?.propertyName}</ModalLabel>
            </TwoColumns>
            <TwoColumns>
              <ModalLabel>
                <IntlMessages id="table.col.geofence.name" /> :
              </ModalLabel>
              <ModalLabel>{data?.name}</ModalLabel>
            </TwoColumns>
            <TwoColumns>
              <ModalLabel>
                <IntlMessages id="table.col.creator" /> :
              </ModalLabel>
              <ModalLabel>{data?.createdBy ?? 'N/A'}</ModalLabel>
            </TwoColumns>
          </>
          <ModalButtonWrapper>
            <Button onClick={onClose}>
              <IntlMessages id="modal.button.close" />
            </Button>
          </ModalButtonWrapper>
        </ModalWrapper>
      </Modal>
    </>
  );
};

export default ViewGeofenceDetailsModal;
